import { Injectable } from "@angular/core";
import { DocumentTypeEnum } from "../enumerators/document-type.enum";
import { PaymentMethodEnum } from "../enumerators/payment-method.enum";
import { PaymentStatusEnum } from "../enumerators/payment-status.enum";
import { ReservationStatusEnum } from "../enumerators/reservation-status.enum";

@Injectable({ providedIn: 'root' })
export class DescriptionService {

    paymentMethodLabel(paymentMethod: any): string {
        const value = Number(paymentMethod);
        return PaymentMethodEnum[value] ?? 'Desconocido';
    }

    documentTypeLabel(documentType: any): string {
        const value = Number(documentType);
        return DocumentTypeEnum[value] ?? 'Desconocido';
    }

    paymentStatus(paymentStatus: any): { label: string; class: string } {
        const value = Number(paymentStatus);
        switch (value) {
            case PaymentStatusEnum.Unpaid:
                return { label: 'Sin pagar', class: 'payment-unpaid' };
            case PaymentStatusEnum.DepositPaid:
                return { label: 'Seña pagada', class: 'payment-deposit' };
            case PaymentStatusEnum.FullyPaid:
                return { label: 'Pago completo', class: 'payment-full' };
            case PaymentStatusEnum.Refunded:
                return { label: 'Reembolsado', class: 'payment-refunded' };
            case PaymentStatusEnum.PartiallyRefunded:
                return { label: 'Parcialmente reembolsado', class: 'payment-partial-refund' };
            default:
                return { label: 'Desconocido', class: '' };
        }
    }

    reservationStatus(status: any): { label: string; class: string } {
        const value = Number(status);
        switch (value) {
            case ReservationStatusEnum.Pending:
                return { label: 'Pendiente', class: 'status-pending' };
            case ReservationStatusEnum.Reserved:
                return { label: 'Confirmada', class: 'status-reserved' };
            case ReservationStatusEnum.CheckedIn:
                return { label: 'Iniciada', class: 'status-checked-in' };
            case ReservationStatusEnum.CheckedOut:
                return { label: 'Finalizada', class: 'status-checked-out' };
            case ReservationStatusEnum.Cancelled:
                return { label: 'Cancelada', class: 'status-cancelled' };
            default:
                return { label: 'Desconocido', class: '' };
        }
    }
}